export type NameValidationErrorKeys<T extends string> = {
  invalidChar: T;
  invalidLength: T;
};

export function getNameValidationError<T extends string>(
  value: string | null | undefined,
  maxLength: number,
  invalidChars: RegExp,
  errorKeys: NameValidationErrorKeys<T>
): T | null {
  const normalized = value?.trim() ?? '';

  if (!normalized) {
    return null;
  }

  if (invalidChars.test(normalized)) {
    return errorKeys.invalidChar;
  }

  if (normalized.length > maxLength) {
    return errorKeys.invalidLength;
  }

  return null;
}
